import { useFormik } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
import React, { useState } from "react";
import ErrorMassage from "./ErrorMassage";
import { useTranslation}  from "react-i18next";
import { Link } from "react-router-dom";

const ContactUsBlock = () => {
  const [errors, setErrors] = useState({});
    const { t } = useTranslation(); // Hook for translations

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      message: '',
      surname : ''
    },

    onSubmit: async (values) => {
      try {
        const response = await axios.post('https://admin.gorditoplus.org/api/message', values);
        console.log('Form submitted successfully:', response.data);
        toast.success('Your message has been send, waiting for answer from admin')
      } catch (error) {
        setErrors(error.response.data.errors);
        console.error('Error submitting form:', error);
      }
    },
  });


  return (
    <div className="space-y-10 w-full mb-[80px]">
      <p className="text-4xl md:text-6xl font-normal font-custom text-center text-darkBg dark:text-lightBg">{t("contacts")}</p>

      <div className="flex flex-col xl:flex-row justify-around items-center items-baseline pr-10 md:pr-20 pl-10 md:pl-52">
        <div className="min-w-[300px] md:min-w-[300px] lg:min-w-[450px]">
          <div>
            <p className="text-darkBg dark:text-lightBg border-l border-[#b4b1aa] px-4">{t("call")}</p>
            <div className="flex gap-x-7 items-center mt-5">
  <Link target="_blank" to={`tel:+37477083388`}>
            +34 657 91 69 82
          </Link> /
           <Link target="_blank" to={`tel:+37477083388`}>
            +34 685 85 10 56
          </Link>            </div>
          </div>
           <div className="mt-20">
            <p className="text-darkBg dark:text-lightBg border-l border-[#b4b1aa] px-4">{t("say")}</p>
            <div className="flex gap-x-7 items-center mt-5">
              <p className="text-[#858585]">comercialveselitolstyak@gmail.com</p>
            </div>
          </div>
        </div>
        <form onSubmit={formik.handleSubmit} className="w-full">
          <div className="space-y-6 flex flex-col mt-14 md:mt-[54px]">
            <input
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              className="border-b border-[#b4b1aa] bg-transparent h-[45px] max-w-[335px] md:max-w-[650px] px-[20px] w-full text-darkBg dark:text-lightBg outline-none"
              placeholder={t("name")}
            />
            { errors.full_name && <ErrorMassage message={errors.full_name} /> }

            <input
              name="surname"
              value={formik.values.surname}
              onChange={formik.handleChange}
              className="border-b border-[#b4b1aa] bg-transparent h-[45px] max-w-[335px] md:max-w-[650px] px-[20px] w-full text-darkBg dark:text-lightBg outline-none"
              placeholder={t("surname")}
            />
            { errors.surname && <ErrorMassage message={errors.surname} /> }
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className="border-b border-[#b4b1aa] bg-transparent h-[45px] max-w-[335px] md:max-w-[650px] px-[20px] w-full text-darkBg dark:text-lightBg outline-none"
              placeholder={t("email")}
            />
            { errors.email && <ErrorMassage message={errors.email} /> }

            <input
              name="phone"
              value={formik.values.phone}
              onChange={formik.handleChange}
              className="border-b border-[#b4b1aa] bg-transparent h-[45px] max-w-[335px] md:max-w-[650px] px-[20px] w-full text-darkBg outline-none"
              placeholder={t("phone")}
            />
            { errors.phone && <ErrorMassage message={errors.phone} /> }

            <textarea
              name="message"
              value={formik.values.message}
              onChange={formik.handleChange}
              className="border-b border-[#b4b1aa] bg-transparent max-w-[335px] md:max-w-[650px] px-[20px] flex items-center justify-center text-darkBg outline-none" rows="4"  cols="50"
              placeholder={t("message")}
            />
            { errors.message && <ErrorMassage message={errors.message} /> }

            <div className="flex justify-center max-w-[650px]">
             <button className="mt-3.5 rounded-[30px] border border-[#b4b1aa] h-[40px] text-darkBg dark:text-lightBg px-10 font-bold">{t("send")}</button>
            </div>
          </div>
        </form>
        </div>
    </div>
  );
};

export default ContactUsBlock;
